export default {
    bindings: {
        content: '<'
    },
    controller: 'reviewController',
    template: require('../views/review.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/components/review.component.js